import { useContextSelector } from 'use-context-selector';
import { CardActionsContext } from './CardActionsContext';

const useFreezeCardData = () => useContextSelector(CardActionsContext, state => state.freezeCardData);

const useCardsErrorState = (errorProperty: 'freezeCardDataError') => {
  const context = useContextSelector(CardActionsContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('useCardsErrorState must be used within CardsProvider');
  }

  return context[errorProperty];
};

const useOnViewCardDetails = () => {
  const context = useContextSelector(CardActionsContext, state => state.onViewCardDetails);

  if (context === undefined) {
    throw new Error('useOnViewCardDetails must be used within CardsProvider');
  }

  return context;
};

const useOnTopUpCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onTopUpCard);

  if (context === undefined) {
    throw new Error('useOnTopUpCard must be used within CardsProvider');
  }

  return context;
};

const useOnFreezeCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onFreezeCard);

  if (context === undefined) {
    throw new Error('useOnFreezeCard must be used within CardsProvider');
  }

  return context;
};

const useOnUnfreezeCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onUnfreezeCard);

  if (context === undefined) {
    throw new Error('useOnUnfreezeCard must be used within CardsProvider');
  }

  return context;
};

const useOnChangePIN = () => {
  const context = useContextSelector(CardActionsContext, state => state.onChangePIN);

  if (context === undefined) {
    throw new Error('useOnChangePIN must be used within CardsProvider');
  }

  return context;
};

const useOnRenewCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onRenewCard);

  if (context === undefined) {
    throw new Error('useOnRenewCard must be used within CardsProvider');
  }

  return context;
};

const useOnReportCardAsDestroyed = () => {
  const context = useContextSelector(CardActionsContext, state => state.onReportCardAsDestroyed);

  if (context === undefined) {
    throw new Error('useOnReportCardAsDestroyed must be used within CardsProvider');
  }

  return context;
};

const useOnReportCardAsStolen = () => {
  const context = useContextSelector(CardActionsContext, state => state.onReportCardAsStolen);

  if (context === undefined) {
    throw new Error('useOnReportCardAsStolen must be used within CardsProvider');
  }

  return context;
};

const useOnResetPINRetry = () => {
  const context = useContextSelector(CardActionsContext, state => state.onResetPINRetry);

  if (context === undefined) {
    throw new Error('useOnResetPINRetry must be used within CardsProvider');
  }

  return context;
};

const useOnResetPinTriesExceeded = () => {
  const context = useContextSelector(CardActionsContext, state => state.onResetPinTriesExceeded);

  if (context === undefined) {
    throw new Error('onResetPinTriesExceeded must be used within CardsProvider');
  }

  return context;
};

const useOnLimits = () => {
  const context = useContextSelector(CardActionsContext, state => state.onLimits);

  if (context === undefined) {
    throw new Error('useOnLimits must be used within CardsProvider');
  }

  return context;
};

const useOnTerminateCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onTerminateCard);

  if (context === undefined) {
    throw new Error('useOnTerminateCard must be used within CardsProvider');
  }

  return context;
};

const useOnActivateCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onActivateCard);

  if (context === undefined) {
    throw new Error('useOnActivateCard must be used within CardsProvider');
  }

  return context;
};

const useOnPermanentBlockCard = () => {
  const context = useContextSelector(CardActionsContext, state => state.onPermanentBlockCard);

  if (context === undefined) {
    throw new Error('useOnPermanentBlockCard must be used within CardsProvider');
  }

  return context;
};

export {
  useCardsErrorState,
  useOnViewCardDetails,
  useOnTopUpCard,
  useOnFreezeCard,
  useOnUnfreezeCard,
  useOnChangePIN,
  useOnRenewCard,
  useOnReportCardAsDestroyed,
  useOnReportCardAsStolen,
  useOnResetPINRetry,
  useOnLimits,
  useOnTerminateCard,
  useOnActivateCard,
  useFreezeCardData,
  useOnPermanentBlockCard,
  useOnResetPinTriesExceeded,
};
